import DOMPurify from 'isomorphic-dompurify';

/** Sanitize and return safe HTML for dangerouslySetInnerHTML. */
export const sanitizeHtml = (html) => {
  if (!html) return '';
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'p', 'br', 'b', 'strong', 'i', 'em', 'u', 'ul', 'ol', 'li',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div', 'span',
      'img', 'figure', 'figcaption',
      'a', 'table', 'thead', 'tbody', 'tr', 'td', 'th',
      'blockquote', 'hr', 'small'
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'title', 'style', 'class', 'width', 'height'],
    ALLOW_DATA_ATTR: false,
  });
};

/** Strip HTML tags and return a plain-text excerpt up to `max` characters. */
export const htmlToExcerpt = (html, max = 160) => {
  if (!html) return '';
  // Decode common entities then strip tags
  const text = html
    .replace(/<style[^>]*>.*?<\/style>/gis, '')
    .replace(/<script[^>]*>.*?<\/script>/gis, '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/\s+/g, ' ')
    .trim();
  return text.length > max ? text.slice(0, max).trimEnd() + '…' : text;
};
